import { render, staticRenderFns } from "./BecomeASponsor.vue?vue&type=template&id=0766274f&"
import script from "./BecomeASponsor.vue?vue&type=script&lang=js&"
export * from "./BecomeASponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports